import { TFunction } from "i18next";

import { unarchiveFidelities } from "../helpers";

type Deps = {
    arrayOfRows: FidelityRow[];
    userID: number;
    franchiseID: string;
    operatorID: string;
    uuidUser: string | null;
    fetchGlobal: FetchGlobal;
    setDataIsUpdated: (v: boolean) => void;
    t: TFunction;
};

export function useUnarchiveBulk(deps: Deps) {
    return async function unarchive() {
        const result = await unarchiveFidelities({
            arrayOfRows: deps.arrayOfRows,
            userID: deps.userID,
            franchiseID: deps.franchiseID,
            operatorID: deps.operatorID,
            uuidUser: deps.uuidUser,
            fetchGlobal: deps.fetchGlobal,
            t: deps.t,
        });
        if (result.ok) {
            deps.setDataIsUpdated(true);
        }
    };
}
